import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import ApiStatus from "../../components/ApiStatus";
import Button from "../../components/Common/Button";
import Divider from "../../components/Common/Divider";
import Heading from "../../components/Common/Heading";
import Section from "../../components/Common/Section";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import { useFetchPrijavaByIzobrazevanjeId, useFetchPrijavaByIzobrazevanjeIdCsv } from "../prijava/IzobrazevanjePrijavaHooks";
import IzobrazevanjeDetailForm from "./IzobrazevanjeDetailForm";
import { useDeactivateIzobrazevanje, useFetchIzobrazevanjeDetail } from "./IzobrazevanjeHooks";
import IzobrazevanjePrijaveList from "./IzobrazevanjePrijaveList";
import styled from "styled-components";
import { IzobrazevanjeVrsta } from "../../utils/Enums";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";
import IzobrazevanjeCommonDetail from "./IzobrazevanjeCommonDetail";
import IzobrazevanjeJavnoDetail from "./IzobrazevanjeJavnoDetail";

const StyledIzobrazevanjeDetailForm = styled.div`
    p{
        margin: 0 0 1rem 0;
    }
    .upper{
        display: flex;
        gap: 2rem;
    }
    .right {
        width: 30%;
    }
    .heading {
        margin-top: 2rem;
        margin-bottom: 1rem;
        font-size: 1.7rem;
    }
    .available{
        margin-bottom: 1rem;
        font-weight: 500;
    }
    .card{
        margin-bottom: 1rem;
    }
    @media (max-width: 650px) {
        .upper{
            flex-direction: column;
            gap: 0;
        }
        .right {
            width: 100%;
            margin-bottom: 1rem;
        }
    }
`

const IzobrazevanjeDetail = () => {
    const nav = useNavigate();
    const { izobrazevanjeId } = useParams();
    if (!izobrazevanjeId)
        throw Error("Manjka parameter izobrazevanjeId");

    const izobrazevanjeIdInt = parseInt(izobrazevanjeId);

    //const { data: izobrazevanjeData, status: izobrazevanjeStatus, isSuccess: izobrazevanjeIsSuccess, error: izobrazevanjeError } = useFetchIzobrazevanjeDetail<IzobrazevanjeDetailType>(izobrazevanjeIdInt);
    const { data: izobrazevanjeData, status: izobrazevanjeStatus, isSuccess: izobrazevanjeIsSuccess, error: izobrazevanjeError } = useFetchIzobrazevanjeDetail(izobrazevanjeIdInt);

    if (izobrazevanjeError) {
        return (
            <Section>
                <Heading>Podrobnosti izobraževanja
                    <Divider />
                </Heading>
                <ApiStatus status={izobrazevanjeStatus}></ApiStatus>
                <div>
                    <span>Prišlo je do napake pri pridobivanju podatkov za izobraževanje.</span>
                    <span className="error">
                        <p className="red">{getApiExceptionObjectFromAxiosError(izobrazevanjeError)?.Message}</p>
                    </span>
                </div>
            </Section>
        );
    }

    if (!izobrazevanjeIsSuccess ) {
        return (
            <ApiStatus status={izobrazevanjeStatus}></ApiStatus>
        );
    }

    if (!izobrazevanjeData) {
        return (
            <div>No data</div>
        );
    }

    if (izobrazevanjeData.vrsta == IzobrazevanjeVrsta.Navadno) {
        return (
            <IzobrazevanjeCommonDetail izobrazevanjeData={izobrazevanjeData} />
        )
    } else if (izobrazevanjeData.vrsta == IzobrazevanjeVrsta.Javno) {
        return (
            <IzobrazevanjeJavnoDetail izobrazevanjeData={izobrazevanjeData} />
        )
    } else {
        return (
            <div>
                <span>Prišlo je do napake pri pridobivanju podatkov za izobraževanje.</span>
                <span className="error">
                    <p className="red">Neznana vrsta izobraževanja</p>
                </span>
            </div>
        )
    }


}

export default IzobrazevanjeDetail;